import {
  Autocomplete,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { TextFieldMA } from "../../styles/styledComponents";
import { theme } from "../../styles/theme";
import { font } from "../../styles/font";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import EditIcon from "@mui/icons-material/Edit";
import { ApplicationContext } from "../../context/application_ctx";
import { updateDetails } from "../../api/controllers/userController";
import { HttpStatusCode } from "axios";
import { GlobalSnackBar } from "../../components/snackBar";

export const OrganisationProfileDetail = ({ admin }) => {
  const { profileDetails, setProfileDetails, setGlobalLoader } =
    useContext(ApplicationContext);

  const [profileSnack, setProfileSnack] = useState(false);
  // const [subDialog, setSubDialog] = useState(false);
  const [error, setError] = useState("");
  // const [subscriptionNav, setSubscriptionNav] = useState(false);

  const [isCompanyProfileEdit, setIsCompanyProfileEdit] = useState({
    information: false,
    description: false,
    address: false,
  });

  // const handleClose = () => {
  //   setSubDialog(false);
  //   setSubscriptionNav(false);
  // };

  useEffect(() => {
    //setGlobalLoader(true)
    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Box
        display="flex"
        width="100%"
        height="100%"
        flexDirection="column"
        gap="21px"
        flex="1"
      >
        {/* company profile */}
        <Box
          display={"flex"}
          height="100%"
          width="100%"
          // width={profileQuery ? "100%" : "50%"}
          // border={`1px solid ${theme.bgBorder}`}
          // borderRadius="8px"
          // backgroundColor={theme.col_4}
          gap="14px"
          flexDirection="column"
          alignItems="center"
          // padding="22px"
          // border="2px solid blue"
        >
          {/* information */}
          <Box
            display={"flex"}
            width="100%"
            position="relative"
            // height={"100%"}
            gap="14px"
            flexDirection="column"
            padding="22px"
            // border={`1px solid ${theme.bgBorder}`}
            border={`1px solid ${theme.col_2_alpha}`}
            borderRadius="8px"
            backgroundColor={theme.col_4}
            // border="2px solid blue"
          >
            <CompanyInfoTab
              admin={admin}
              companyDetails={profileDetails}
              setCompanyDetails={setProfileDetails}
              isCompanyProfileEdit={isCompanyProfileEdit}
              setIsCompanyProfileEdit={setIsCompanyProfileEdit}
            />
          </Box>

          {/* description */}
          <Box
            display={"flex"}
            width="100%"
            position="relative"
            // height={"100%"}
            gap="14px"
            flexDirection="column"
            padding="22px"
            // border={`1px solid ${theme.bgBorder}`}
            border={`1px solid ${theme.col_2_alpha}`}
            borderRadius="8px"
            backgroundColor={theme.col_4}
            // border="2px solid blue"
          >
            <CompanyDescriptionTab
              admin={admin}
              companyDetails={profileDetails}
              setCompanyDetails={setProfileDetails}
              isCompanyProfileEdit={isCompanyProfileEdit}
              setIsCompanyProfileEdit={setIsCompanyProfileEdit}
            />
          </Box>

          {/* address */}
          <Box
            display={"flex"}
            width="100%"
            position="relative"
            // height={"100%"}
            gap="14px"
            flexDirection="column"
            padding="22px"
            // border={`1px solid ${theme.bgBorder}`}
            border={`1px solid ${theme.col_2_alpha}`}
            borderRadius="8px"
            backgroundColor={theme.col_4}
            // border="2px solid blue"
          >
            <CompanyAddressTab
              admin={admin}
              companyDetails={profileDetails}
              setCompanyDetails={setProfileDetails}
              isCompanyProfileEdit={isCompanyProfileEdit}
              setIsCompanyProfileEdit={setIsCompanyProfileEdit}
            />
          </Box>
        </Box>
      </Box>

      {(isCompanyProfileEdit.information ||
        isCompanyProfileEdit.description ||
        isCompanyProfileEdit.address) && (
        <UpdateCompanyInfoDialog
          companyDetails={profileDetails}
          setCompanyDetails={setProfileDetails}
          setError={setError}
          setProfileSnack={setProfileSnack}
          isCompanyProfileEdit={isCompanyProfileEdit}
          setIsCompanyProfileEdit={setIsCompanyProfileEdit}
        />
      )}
      <GlobalSnackBar
        open={profileSnack}
        title={error}
        close={setProfileSnack}
      />
      {/* <SubscriptionDialog
        setSubDialog={setSubDialog}
        setSubscriptionNav={setSubscriptionNav}
        subscriptionNav={subscriptionNav}
        setError={setError}
        upgrade={true}
        subDialog={subDialog}
        handleClose={handleClose}
        setProfileSnack={setProfileSnack}
      /> */}
    </>
  );
};

export const CompanyInfoTab = ({
  companyDetails,
  admin,
  setCompanyDetails,
  isCompanyProfileEdit,
  setIsCompanyProfileEdit,
}) => {
  // const [isCompanyProfileEdit, setIsCompanyProfileEdit] = useState(false);
  const { setGlobalLoader } = useContext(ApplicationContext);

  useEffect(() => {
    //setGlobalLoader(true)
    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Box
        display={"flex"}
        width="100%"
        // gap="15px"
        // height={"25px"}
        flexDirection="column"
        gap={1}
        // alignItems="center"
        // border="2px solid blue"
      >
        {/* info heading */}
        <Box
          display={"flex"}
          // width="100%"
          flex="1"
          gap="15px"
          // minHeight={"40px"}
          // maxHeight={"40px"}
          // paddingLeft="11px"
          // paddingRight="11px"
          alignItems="flex-start"
          // backgroundColor={theme.col_2_alpha}
          borderRadius="6px"
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Information
          </Typography>

          {admin ? (
            <></>
          ) : (
            <IconButton
              onClick={() =>
                setIsCompanyProfileEdit({
                  ...isCompanyProfileEdit,
                  information: true,
                })
              }
            >
              <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
            </IconButton>
          )}
        </Box>

        {/* info body */}
        <Box
          display="flex"
          width="100%"
          flexDirection={"column"}
          gap={1}
          alignItems="flex-start"
        >
          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Company Name</FieldHeading>
            <FieldValue>{companyDetails?.companyName}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Company Url</FieldHeading>
            <FieldValue>{companyDetails?.companyUrl}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Company Registration No</FieldHeading>
            <FieldValue>{companyDetails?.companyRegistrationNumber}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>VAT Registration No</FieldHeading>
            {/* <FieldValue>{profileDetails?.phoneNumber?.replace(/[^+0-9]/, "")}</FieldValue> */}
            <FieldValue>{companyDetails?.vatRegistrationNumber}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Legal Status of Company</FieldHeading>
            {/* <FieldValue>{profileDetails?.phoneNumber?.replace(/[^+0-9]/, "")}</FieldValue> */}
            <FieldValue>{companyDetails?.legalStatus}</FieldValue>
          </Box>
        </Box>

        {/* {isCompanyProfileEdit.information &&
          <UpdateCompanyInfoDialog
            companyDetails={companyDetails}
            setCompanyDetails={setCompanyDetails}
            isCompanyProfileEdit={isCompanyProfileEdit}
            setIsCompanyProfileEdit={setIsCompanyProfileEdit}
          />} */}
      </Box>
    </>
  );
};

export const CompanyDescriptionTab = ({
  companyDetails,
  admin,
  setCompanyDetails,
  isCompanyProfileEdit,
  setIsCompanyProfileEdit,
}) => {
  // const [isCompanyProfileEdit, setIsCompanyProfileEdit] = useState(false);
  const { setGlobalLoader } = useContext(ApplicationContext);

  useEffect(() => {
    //setGlobalLoader(true)
    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  console.log(companyDetails, "companyDetail description");

  return (
    <>
      <Box
        display={"flex"}
        width="100%"
        // gap="15px"
        // height={"25px"}
        flexDirection="column"
        gap={1}
        // alignItems="center"
        // border="2px solid blue"
      >
        {/* info heading */}
        <Box
          display={"flex"}
          // width="100%"
          flex="1"
          gap="15px"
          // minHeight={"40px"}
          // maxHeight={"40px"}
          // paddingLeft="11px"
          // paddingRight="11px"
          alignItems="flex-start"
          // backgroundColor={theme.col_2_alpha}
          borderRadius="6px"
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Description
          </Typography>

          {admin ? (
            <></>
          ) : (
            <IconButton
              onClick={() =>
                setIsCompanyProfileEdit({
                  ...isCompanyProfileEdit,
                  description: true,
                })
              }
            >
              <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
            </IconButton>
          )}
        </Box>

        {/* info body */}
        <Box
          display="flex"
          width="100%"
          flexDirection={"column"}
          gap={1}
          alignItems="flex-start"
        >
          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Company Description</FieldHeading>
            <FieldValue>{companyDetails?.companyDescription}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Company Keywords</FieldHeading>
            <FieldValue>{companyDetails?.companyKeywords}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Number of Employees</FieldHeading>
            <FieldValue>{companyDetails?.numberOfEmployees}</FieldValue>
          </Box>
        </Box>

        {/* {isCompanyProfileEdit.description &&
          <UpdateCompanyInfoDialog
            companyDetails={companyDetails}
            setCompanyDetails={setCompanyDetails}
            isCompanyProfileEdit={isCompanyProfileEdit}
            setIsCompanyProfileEdit={setIsCompanyProfileEdit}
          />} */}
      </Box>
    </>
  );
};

export const CompanyAddressTab = ({
  companyDetails,
  admin,
  setCompanyDetails,
  isCompanyProfileEdit,
  setIsCompanyProfileEdit,
}) => {
  // const [isCompanyProfileEdit, setIsCompanyProfileEdit] = useState(false);

  console.log(companyDetails, "companyDetail company address");

  return (
    <>
      <Box
        display={"flex"}
        width="100%"
        // gap="15px"
        // height={"25px"}
        flexDirection="column"
        gap={1}
        // alignItems="center"
        // border="2px solid blue"
      >
        {/* info heading */}
        <Box
          display={"flex"}
          // width="100%"
          flex="1"
          gap="15px"
          // minHeight={"40px"}
          // maxHeight={"40px"}
          // paddingLeft="11px"
          // paddingRight="11px"
          alignItems="flex-start"
          // backgroundColor={theme.col_2_alpha}
          borderRadius="6px"
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Address
          </Typography>

          {admin ? (
            <></>
          ) : (
            <IconButton
              onClick={() =>
                setIsCompanyProfileEdit({
                  ...isCompanyProfileEdit,
                  address: true,
                })
              }
            >
              <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
            </IconButton>
          )}
        </Box>

        {/* info body */}
        <Box
          display="flex"
          width="100%"
          flexDirection={"column"}
          gap={1}
          alignItems="flex-start"
        >
          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Company Address</FieldHeading>
            <FieldValue>{companyDetails?.companyAddress}</FieldValue>
          </Box>
        </Box>

        {/* {isCompanyProfileEdit.address &&
          <UpdateCompanyInfoDialog
            companyDetails={companyDetails}
            setCompanyDetails={setCompanyDetails}
            isCompanyProfileEdit={isCompanyProfileEdit}
            setIsCompanyProfileEdit={setIsCompanyProfileEdit}
          />} */}
      </Box>
    </>
  );
};

export const FieldHeading = (props) => {
  // console.log(props, props.children, "props")
  return (
    <Typography whiteSpace='nowrap' fontWeight="bold" color={theme.col_6} {...props}>
      {props.children}
      {!props.dialog && ":"}
    </Typography>
  );
};

export const FieldValue = (props) => {
  // console.log(props, props.children, "props")
  return (
    <Typography
      textOverflow={"ellipsis"}
      overflow={"hidden"}
      color={theme.col_6}
      {...props}
    >
      {props.children}
    </Typography>
  );
};

export const UpdateCompanyInfoDialog = ({
  companyDetails,
  setCompanyDetails,
  setProfileSnack,
  setError,
  isCompanyProfileEdit,
  setIsCompanyProfileEdit,
}) => {
  const [editCompanyProfile, setEditCompanyProfile] = useState(true);
  // const [editCompanyDescription, setEditCompanyDescription] = useState(true);

  const [loaderState, setLoaderState] = useState(false);

  const legalStatusList = [
    { title: "Chartable Incorporated Company (CIO)", id: 0 },
    { title: "Communty Interest Company (CIC)", id: 1 },
    { title: "General Patnership", id: 2 },
    { title: "Industrial & Provident Society", id: 3 },
    { title: "Limited Liability Partnership (LLP)", id: 4 },
    { title: "Linted Pameship", id: 5 },
    { title: "Private Company Limted by Guarantee (LTD)", id: 6 },
    { title: "Private Limited Company (LTD)", id: 7 },
    { title: "Public Limied Company (PLC)", id: 8 },
    { title: "Sole Trader", id: 9 },
    { title: "Unlimited Company", id: 10 },
    { title: "other", id: 11 },
  ];
  let legalValue;
  legalStatusList.map((data) => {
    if (data?.title === companyDetails?.legalStatus) {
      legalValue = data;
    }
    return false;
  });

  const [profileDetails, setProfileDetails] = useState({
    companyName: companyDetails?.companyName,
    companyAddress: companyDetails?.companyAddress,
    companyUrl: companyDetails?.companyUrl,
    companyRegistrationNumber: companyDetails?.companyRegistrationNumber,
    vatRegistrationNumber: companyDetails?.vatRegistrationNumber,
    companyKeywords: companyDetails?.companyKeywords,
    numberOfEmployees: companyDetails?.numberOfEmployees,
    companyDescription: companyDetails?.companyDescription,
    legalStatus: legalValue,
  });

  const handleInformationDetailsCancel = () => {
    setProfileDetails({
      companyName: companyDetails?.companyName,
      companyUrl: companyDetails?.companyUrl,
      companyRegistrationNumber: companyDetails?.companyRegistrationNumber,
      vatRegistrationNumber: companyDetails?.vatRegistrationNumber,
      legalStatus: legalValue,
    });
    // setEditCompanyProfile(true);

    setIsCompanyProfileEdit({
      ...isCompanyProfileEdit,
      information: false,
      description: false,
      address: false,
    });
  };

  const handleDescriptionDetailsCancel = () => {
    setProfileDetails({
      // companyName: companyDetails?.companyName,
      // companyAddress: companyDetails?.companyAddress,
      // companyUrl: companyDetails?.companyUrl,
      // companyRegistrationNumber: companyDetails?.companyRegistrationNumber,
      // vatRegistrationNumber: companyDetails?.vatRegistrationNumber,
      companyKeywords: companyDetails?.companyKeywords,
      numberOfEmployees: companyDetails?.numberOfEmployees,
      companyDescription: companyDetails?.companyDescription,
      // legalStatus: legalValue,
    });
    // setEditCompanyDescription(true);

    setIsCompanyProfileEdit({
      ...isCompanyProfileEdit,
      information: false,
      description: false,
      address: false,
    });
  };

  console.log(profileDetails, "profiledetails");

  const handleAddressDetailsCancel = () => {
    setProfileDetails({
      // companyName: companyDetails?.companyName,
      companyAddress: companyDetails?.companyAddress,
      // companyUrl: companyDetails?.companyUrl,
      // companyRegistrationNumber: companyDetails?.companyRegistrationNumber,
      // vatRegistrationNumber: companyDetails?.vatRegistrationNumber,
      // companyKeywords: companyDetails?.companyKeywords,
      // numberOfEmployees: companyDetails?.numberOfEmployees,
      // companyDescription: companyDetails?.companyDescription,
      // legalStatus: legalValue,
    });
    // setEditCompanyDescription(true);

    setIsCompanyProfileEdit({
      ...isCompanyProfileEdit,
      information: false,
      description: false,
      address: false,
    });
  };

  // const handleDetails = async () => {
  //   // setLoginNavigation(3);
  //   if (!profileDetails?.companyName) {
  //     profileDetails.companyName = "";
  //   }
  //   if (!profileDetails?.companyAddress) {
  //     profileDetails.companyAddress = "";
  //   }
  //   if (!profileDetails?.companyKeywords) {
  //     profileDetails.companyKeywords = "";
  //   }
  //   if (!profileDetails?.companyRegistrationNumber) {
  //     profileDetails.companyRegistrationNumber = "";
  //   }
  //   if (!profileDetails?.vatRegistrationNumber) {
  //     profileDetails.vatRegistrationNumber = "";
  //   }
  //   if (!profileDetails?.legalStatus) {
  //     profileDetails.legalStatus = null;
  //   }
  //   if (!profileDetails?.numberOfEmployees) {
  //     profileDetails.numberOfEmployees = "";
  //   }

  //   setProfileDetails({ ...profileDetails });
  //   if (
  //     profileDetails?.companyName &&
  //     profileDetails?.companyAddress &&
  //     profileDetails?.companyKeywords &&
  //     profileDetails?.companyRegistrationNumber &&
  //     profileDetails?.vatRegistrationNumber &&
  //     profileDetails?.legalStatus &&
  //     profileDetails?.numberOfEmployees
  //   ) {
  //     console.log("yes ready to send");
  //     profileDetails.legalStatus = profileDetails?.legalStatus?.title;
  //     let token = localStorage.getItem("api-token");
  //     try {
  //       setLoaderState(true);

  //       let response = await updateDetails(profileDetails, token);
  //       console.log(response, "responseLogin");
  //       if (response.status === HttpStatusCode.Ok) {
  //         setError(response.data.message);
  //         setProfileSnack(true);
  //         setTimeout(() => {
  //           setProfileSnack(false);
  //         }, 3000);
  //         setTimeout(() => {
  //           setLoaderState(false);
  //           setEditCompanyProfile(true);
  //         }, 1000);
  //         // setError(response.data.message);
  //         // setSignInSnack(true);
  //         // setTimeout(() => {
  //         //   setSignInSnack(false);
  //         // }, 3000);
  //         //   setLoaderState(false);
  //         //   localStorage.setItem("api-token", response.data.token);
  //         //   navigate("/admin-dashboard");
  //       }
  //       if (response.status === HttpStatusCode.BadRequest) {
  //         setTimeout(() => {
  //           setLoaderState(false);
  //         }, 1000);
  //         //   setError(response.data.message);
  //         //   setSignInSnack(true);
  //         //   setTimeout(() => {
  //         //     setLoginNavigation(1);
  //         //     setSignInSnack(false);
  //         //   }, 3000);
  //       }
  //       if (response.status === HttpStatusCode.Unauthorized) {
  //         setLoaderState(false);
  //         //   setError(response.data.message);
  //         //   setSignInSnack(true);
  //         //   setTimeout(() => {
  //         //     setSignInSnack(false);
  //         //   }, 3000);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // };

  const handleUpdateInformationDetails = async () => {
    let checkEqual = checkIfInformationValuesEqual();

    if (checkEqual) {
      return;
    }

    // setLoginNavigation(3);
    if (!profileDetails?.companyName) {
      profileDetails.companyName = "";
    }
    if (!profileDetails?.companyUrl) {
      profileDetails.companyUrl = "";
    }
    if (!profileDetails?.companyRegistrationNumber) {
      profileDetails.companyRegistrationNumber = "";
    }
    if (!profileDetails?.legalStatus) {
      profileDetails.legalStatus = null;
    }
    if (!profileDetails?.vatRegistrationNumber) {
      profileDetails.vatRegistrationNumber = "";
    }

    setProfileDetails({ ...profileDetails });
    // if (
    //   profileDetails?.companyName &&
    //   profileDetails?.companyUrl &&
    //   profileDetails?.companyRegistrationNumber &&
    //   profileDetails?.vatRegistrationNumber &&
    //   profileDetails?.legalStatus
    // ) {
    console.log("yes ready to send");

    if ("legalStatus" in profileDetails && profileDetails.legalStatus) {
      profileDetails.legalStatus = profileDetails?.legalStatus?.title;
    }

    // if (profileDetails.companyRegistrationNumber) {
    //   profileDetails.companyRegistrationNumber = profileDetails.companyRegistrationNumber;
    // }

    // if (profileDetails.vatRegistrationNumber) {
    //   profileDetails.vatRegistrationNumber = profileDetails.vatRegistrationNumber;
    // }

    let body = {
      companyName: profileDetails?.companyName,
      companyUrl: profileDetails?.companyUrl,
      companyRegistrationNumber: profileDetails?.companyRegistrationNumber,
      vatRegistrationNumber: profileDetails?.vatRegistrationNumber,
      legalStatus: profileDetails?.legalStatus,
    };

    let token = localStorage.getItem("api-token");
    try {
      setLoaderState(true);

      let response = await updateDetails(body, token);
      console.log(response, "response update");
      setLoaderState(false);

      if (response.status === HttpStatusCode.Ok) {
        setCompanyDetails(response.data.updatedOrganization);

        setIsCompanyProfileEdit({
          ...isCompanyProfileEdit,
          information: false,
        });

        setError(response.data.message);
        setProfileSnack(true);

        // setTimeout(() => {
        //   setProfileSnack(false);
        // }, 3000);
        // setTimeout(() => {
        //   setLoaderState(false);
        //   setEditCompanyProfile(true);
        // }, 1000);

        // setError(response.data.message);
        // setSignInSnack(true);
        // setTimeout(() => {
        //   setSignInSnack(false);
        // }, 3000);
        //   setLoaderState(false);
        //   localStorage.setItem("api-token", response.data.token);
        //   navigate("/admin-dashboard");
      }
      if (response.status === HttpStatusCode.BadRequest) {
        // setTimeout(() => {
        //   setLoaderState(false);
        // }, 1000);

        setError(response.data.message);
        setProfileSnack(true);
        //   setSignInSnack(true);
        //   setTimeout(() => {
        //     setLoginNavigation(1);
        //     setSignInSnack(false);
        //   }, 3000);
      }
      if (response.status === HttpStatusCode.Unauthorized) {
        setError(response.data.message);
        setProfileSnack(true);

        // setLoaderState(false);
        //   setError(response.data.message);
        //   setSignInSnack(true);
        //   setTimeout(() => {
        //     setSignInSnack(false);
        //   }, 3000);
      }
    } catch (error) {
      console.log(error);
    }
    // }
  };

  const handleUpdateDescriptionDetails = async () => {
    let checkEqual = checkIfDescriptionValuesEqual();

    if (checkEqual) {
      return;
    }

    // setLoginNavigation(3);
    if (!profileDetails?.companyDescription) {
      profileDetails.companyDescription = "";
    }
    if (!profileDetails?.companyKeywords) {
      profileDetails.companyKeywords = "";
    }
    if (!profileDetails?.numberOfEmployees) {
      profileDetails.numberOfEmployees = "";
    }

    setProfileDetails({ ...profileDetails });

    console.log("yes ready to send");

    let body = {
      numberOfEmployees: Number(profileDetails?.numberOfEmployees),
      companyDescription: profileDetails?.companyDescription,
      companyKeywords: profileDetails?.companyKeywords,
    };

    let token = localStorage.getItem("api-token");
    try {
      setLoaderState(true);

      let response = await updateDetails(body, token);
      console.log(response, "response update");
      setLoaderState(false);

      if (response.status === HttpStatusCode.Ok) {
        setCompanyDetails(response.data.updatedOrganization);
        setIsCompanyProfileEdit({
          ...isCompanyProfileEdit,
          description: false,
        });

        setError(response.data.message);
        setProfileSnack(true);

        // setTimeout(() => {
        //   setProfileSnack(false);
        // }, 3000);
        // setTimeout(() => {
        //   setLoaderState(false);
        //   setEditCompanyProfile(true);
        // }, 1000);

        // setError(response.data.message);
        // setSignInSnack(true);
        // setTimeout(() => {
        //   setSignInSnack(false);
        // }, 3000);
        //   setLoaderState(false);
        //   localStorage.setItem("api-token", response.data.token);
        //   navigate("/admin-dashboard");
      }
      if (response.status === HttpStatusCode.BadRequest) {
        // setTimeout(() => {
        //   setLoaderState(false);
        // }, 1000);

        setError(response.data.message);
        setProfileSnack(true);
        //   setSignInSnack(true);
        //   setTimeout(() => {
        //     setLoginNavigation(1);
        //     setSignInSnack(false);
        //   }, 3000);
      }
      if (response.status === HttpStatusCode.Unauthorized) {
        setError(response.data.message);
        setProfileSnack(true);
        // setLoaderState(false);
        //   setError(response.data.message);
        //   setSignInSnack(true);
        //   setTimeout(() => {
        //     setSignInSnack(false);
        //   }, 3000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateAddressDetails = async () => {
    let checkEqual = checkIfAddressValuesEqual();

    if (checkEqual) {
      return;
    }

    // setLoginNavigation(3);
    if (!profileDetails?.companyAddress) {
      profileDetails.companyAddress = "";
    }

    setProfileDetails({ ...profileDetails });

    console.log("yes ready to send");

    let body = {
      companyAddress: profileDetails?.companyAddress,
    };

    let token = localStorage.getItem("api-token");
    try {
      setLoaderState(true);

      let response = await updateDetails(body, token);
      console.log(response, "response update");
      setLoaderState(false);

      if (response.status === HttpStatusCode.Ok) {
        setCompanyDetails(response.data.updatedOrganization);
        setIsCompanyProfileEdit({ ...isCompanyProfileEdit, address: false });

        setError(response.data.message);
        setProfileSnack(true);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setError(response.data.message);
        setProfileSnack(true);
      }
      if (response.status === HttpStatusCode.Unauthorized) {
        setError(response.data.message);
        setProfileSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkIfInformationValuesEqual = () => {
    if (
      profileDetails?.companyName === companyDetails?.companyName &&
      profileDetails.companyUrl === companyDetails?.companyUrl &&
      profileDetails.companyRegistrationNumber?.toString() ===
        companyDetails?.companyRegistrationNumber?.toString() &&
      profileDetails.legalStatus?.title === companyDetails?.legalStatus &&
      profileDetails.vatRegistrationNumber?.toString() ===
        companyDetails?.vatRegistrationNumber?.toString()
    ) {
      // console.log("same")
      return true;
    } else {
      // console.log("not same")
      return false;
    }
  };

  const checkIfDescriptionValuesEqual = () => {
    if (
      profileDetails?.companyKeywords === companyDetails?.companyKeywords &&
      profileDetails?.numberOfEmployees?.toString() ===
        companyDetails?.numberOfEmployees?.toString() &&
      profileDetails?.companyDescription === companyDetails?.companyDescription
    ) {
      // console.log("same")
      return true;
    } else {
      // console.log("not same")
      return false;
    }
  };

  const checkIfAddressValuesEqual = () => {
    if (profileDetails?.companyAddress === companyDetails?.companyAddress) {
      // console.log("same")
      return true;
    } else {
      // console.log("not same")
      return false;
    }
  };

  useEffect(() => {
    setProfileDetails({
      companyName: companyDetails?.companyName,
      companyAddress: companyDetails?.companyAddress,
      companyUrl: companyDetails?.companyUrl,
      companyRegistrationNumber: companyDetails?.companyRegistrationNumber,
      vatRegistrationNumber: companyDetails?.vatRegistrationNumber,
      companyKeywords: companyDetails?.companyKeywords,
      numberOfEmployees: companyDetails?.numberOfEmployees,
      companyDescription: companyDetails?.companyDescription,
      legalStatus: legalValue,
    });
  }, [companyDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog
      open={isCompanyProfileEdit}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "60%",
          //  minHeight: "60vh"
        },
      }}
    >
      {/* <DialogTitle>
        <Box
          display={"flex"}
          alignItems="center"
          justifyContent="flex-end"
          gap={1}
          px={2}
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Company Profile Edit
          </Typography>

          {isCompanyProfileEdit.address && <IconButton disabled sx={{ ml: "auto" }}>
            <Add sx={{ fontSize: "22px", color: theme.statusDisabled }} />
          </IconButton>}
          <IconButton onClick={() => setIsCompanyProfileEdit({ ...isCompanyProfileEdit, information: false, description: false, address: false })} >
            <Close sx={{ fontSize: "22px", color: theme.col_3 }} />
          </IconButton>
        </Box>
      </DialogTitle> */}

      <DialogContent>
        <Box>
          {loaderState ? (
            <Box
              display="flex"
              alignItems="center"
              flexDirection="column"
              width={"100%"}
              height="100%"
              zIndex="100"
              sx={{ backdropFilter: "blur(1px)" }}
              justifyContent="center"
              position={"absolute"}
            >
              <CircularProgress sx={{ color: theme.col_3 }} size="50px" />
            </Box>
          ) : (
            <></>
          )}

          {/* audit history */}
          {/* <Box display="flex" alignItems="center" justifyContent="flex-end">
        <Typography>View Audio History</Typography>
      </Box> */}

          {/* company info */}
          {isCompanyProfileEdit.information && (
            <Box
              display={"flex"}
              width="100%"
              gap={2}
              px={2}
              mb={2}
              // height={"25px"}
              flexDirection="column"
              // alignItems="center"
              // border="2px solid blue"
            >
              <Box
                display={"flex"}
                // width="100%"
                flex="1"
                gap="15px"
                minHeight={"40px"}
                maxHeight={"40px"}
                // paddingLeft="11px"
                // paddingRight="11px"
                alignItems="center"
                // backgroundColor={theme.col_3_alpha}
                borderRadius="6px"
              >
                <Typography
                  // padding="6px 6px 6px 11px"
                  flex="1"
                  fontSize={font.size.fs_5}
                  color={theme.col_2}
                  fontFamily={font.family.fm_2}
                  fontWeight="bold"
                >
                  Information
                </Typography>
                {false ? (
                  <IconButton onClick={() => setEditCompanyProfile(false)}>
                    <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
                  </IconButton>
                ) : (
                  <>
                    <Typography
                      onClick={handleUpdateInformationDetails}
                      // padding="6px 6px 6px 11px"
                      fontSize={font.size.fs_6}
                      color={
                        checkIfInformationValuesEqual() === true ||
                        !profileDetails.companyName
                          ? theme.statusDisabled
                          : theme.col_3
                      }
                      fontFamily={font.family.fm_2}
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                    >
                      Save
                    </Typography>
                    <Typography
                      onClick={handleInformationDetailsCancel}
                      // padding="6px 6px 6px 11px"
                      fontSize={font.size.fs_6}
                      color={theme.col_2}
                      fontFamily={font.family.fm_2}
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                    >
                      Cancel
                    </Typography>
                  </>
                )}
              </Box>

              <Box
                display={"flex"}
                width="100%"
                gap={4}
                flexWrap="wrap"
                // height={"25px"}
                // alignItems="center"
              >
                {console.log(profileDetails, "profdeta")}

                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="Company Name" dialog />
                  <TextFieldMA
                    // disabled={editCompanyProfile}
                    size="small"
                    required
                    value={profileDetails?.companyName}
                    // error={
                    //   profileDetails?.companyName === null
                    //     ? false
                    //     : profileDetails?.companyName === ""
                    //       ? true
                    //       : false
                    // }
                    // helperText={
                    //   profileDetails?.companyName === null
                    //     ? ""
                    //     : profileDetails?.companyName === ""
                    //       ? "Company name is required"
                    //       : ""
                    // }
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        companyName: e.target.value,
                      })
                    }
                    fullWidth
                    inputProps={{ maxLength: 40 }}
                    placeholder="Company Name"
                  />
                </Box>

                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="Company URL" dialog />
                  <TextFieldMA
                    // disabled={editCompanyProfile}
                    size="small"
                    value={profileDetails?.companyUrl}
                    //   required
                    //   error={
                    //     profileDetails.companyUrl === null
                    //       ? false
                    //       : profileDetails.companyUrl === ""
                    //       ? true
                    //       : false
                    //   }
                    //   helperText={
                    //     profileDetails.companyUrl === null
                    //       ? ""
                    //       : profileDetails.companyUrl === ""
                    //       ? "Company URL is required"
                    //       : ""
                    //   }
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        companyUrl: e.target.value,
                      })
                    }
                    fullWidth
                    placeholder="Company URL"
                  />
                </Box>
              </Box>

              <Box
                display={"flex"}
                width="100%"
                gap={4}
                mt={2}
                flexWrap="wrap"
                // height={"25px"}
                // alignItems="center"
              >
                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="Company Registration No" dialog />
                  <TextFieldMA
                    // type="number"
                    // disabled={editCompanyProfile}
                    size="small"
                    required
                    value={profileDetails?.companyRegistrationNumber}
                    // error={
                    //   profileDetails?.companyRegistrationNumber === null
                    //     ? false
                    //     : profileDetails?.companyRegistrationNumber === ""
                    //       ? true
                    //       : false
                    // }
                    // helperText={
                    //   profileDetails?.companyRegistrationNumber === null
                    //     ? ""
                    //     : profileDetails?.companyRegistrationNumber === ""
                    //       ? "Company register no is required"
                    //       : ""
                    // }
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        companyRegistrationNumber: e.target.value.replace(
                          /[^0-9]/,
                          ""
                        ),
                      })
                    }
                    fullWidth
                    placeholder="Company Registration No"
                  />
                </Box>

                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="Legal Status Of Company" dialog />
                  <Autocomplete
                    // disabled={editCompanyProfile}
                    size="small"
                    fullWidth
                    //   multiple
                    onChange={(event, newValue) => {
                      // console.log(newValue);
                      setProfileDetails({
                        ...profileDetails,
                        legalStatus: newValue,
                      });
                      //  setlegalStatus(newValue)
                    }}
                    isOptionEqualToValue={(option, val) =>
                      option?.id === val?.id
                    }
                    value={profileDetails?.legalStatus}
                    //   inputValue={inputValue}
                    //   onInputChange={(event, newInputValue) => {
                    //     console.log(newInputValue);
                    //   }}
                    id="checkboxes-tags-demo"
                    options={legalStatusList}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option?.title}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          // checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option?.title}
                      </li>
                    )}
                    //   style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextFieldMA
                        disabled={editCompanyProfile}
                        size="small"
                        fullwidth
                        // error={profileDetails?.legalStatus === null ? true : false}
                        // helperText={
                        //   profileDetails?.legalStatus === null
                        //     ? "Job Title is required"
                        //     : ""
                        // }
                        {...params}
                        placeholder="Legal Status of Company"
                        // placeholder="Favorites"
                      />
                    )}
                  />
                </Box>
              </Box>

              <Box
                display={"flex"}
                width="100%"
                gap={4}
                mt={2}
                flexWrap="wrap"
                // height={"25px"}
                // alignItems="center"
              >
                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="VAT Registration No" dialog />
                  <TextFieldMA
                    // type="number"
                    // disabled={editCompanyProfile}
                    size="small"
                    required
                    value={profileDetails?.vatRegistrationNumber}
                    // error={
                    //   profileDetails?.vatRegistrationNumber === null
                    //     ? false
                    //     : profileDetails?.vatRegistrationNumber === ""
                    //       ? true
                    //       : false
                    // }
                    // helperText={
                    //   profileDetails?.vatRegistrationNumber === null
                    //     ? ""
                    //     : profileDetails?.vatRegistrationNumber === ""
                    //       ? "Company VAT no is required"
                    //       : ""
                    // }
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        vatRegistrationNumber: e.target.value.replace(
                          /[^0-9]/,
                          ""
                        ),
                      })
                    }
                    fullWidth
                    placeholder="VAT Registration No"
                  />
                </Box>
              </Box>
            </Box>
          )}

          {/* company description */}
          {isCompanyProfileEdit.description && (
            <Box
              display={"flex"}
              width="100%"
              gap={2}
              mb={2}
              px={2}
              // height={"25px"}
              flexDirection="column"
              // alignItems="center"
              // mt={2}
            >
              <Box
                display={"flex"}
                // width="100%"
                flex="1"
                gap="15px"
                minHeight={"40px"}
                maxHeight={"40px"}
                // paddingLeft="11px"
                // paddingRight="11px"
                alignItems="center"
                // backgroundColor={theme.col_3_alpha}
                borderRadius="6px"
              >
                <Typography
                  // padding="6px 6px 6px 11px"
                  flex="1"
                  fontSize={font.size.fs_5}
                  color={theme.col_2}
                  fontFamily={font.family.fm_2}
                  fontWeight="bold"
                >
                  Description
                </Typography>
                {false ? (
                  <IconButton>
                    <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
                  </IconButton>
                ) : (
                  <>
                    <Typography
                      onClick={handleUpdateDescriptionDetails}
                      // padding="6px 6px 6px 11px"
                      fontSize={font.size.fs_6}
                      color={
                        checkIfDescriptionValuesEqual() === true
                          ? theme.statusDisabled
                          : theme.col_3
                      }
                      fontFamily={font.family.fm_2}
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                    >
                      Save
                    </Typography>
                    <Typography
                      onClick={handleDescriptionDetailsCancel}
                      // padding="6px 6px 6px 11px"
                      fontSize={font.size.fs_6}
                      color={theme.col_2}
                      fontFamily={font.family.fm_2}
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                    >
                      Cancel
                    </Typography>
                  </>
                )}
              </Box>

              <Box
                display="flex"
                width="100%"
                // flexDirection={"column"}
                gap={4}
                flexWrap="wrap"
                justifyContent="center"
                // border="2px solid blue"
              >
                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="Description" dialog />
                  {/* <TextFieldMA
                  multiline
                  rows={4}
                  // disabled={editCompanyDescription}
                  size="small"
                  value={profileDetails?.companyDescription}
                  //   required
                  // multiline
                  // maxRows={4}
                  // error={
                  //   profileDetails.companyDescription === null
                  //     ? false
                  //     : profileDetails.companyDescription === ""
                  //     ? true
                  //     : false
                  // }
                  // helperText={
                  //   profileDetails.companyDescription === null
                  //     ? ""
                  //     : profileDetails.companyDescription === ""
                  //     ? "Email is required"
                  //     : ""
                  // }
                  onChange={(e) =>
                    setProfileDetails({
                      ...profileDetails,
                      companyDescription: e.target.value,
                    })
                  }
                  fullWidth
                  placeholder="Company Description"
                /> */}
                  <TextareaAutosize
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        companyDescription: e.target.value,
                      })
                    }
                    style={{
                      width: "100%",
                      resize: "none",
                      borderRadius: "4px",
                      border: `1px solid ${theme.col_2}`,
                      paddingLeft: "12px",
                      paddingTop: "12px",
                    }}
                    placeholder="Company Description"
                    value={profileDetails?.companyDescription}
                    id="textArea1"
                    maxRows={6}
                    minRows={6}
                  />
                </Box>

                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="Company Keywords" dialog />
                  <TextFieldMA
                    // disabled={editCompanyDescription}
                    size="small"
                    required
                    value={profileDetails?.companyKeywords}
                    // error={
                    //   profileDetails?.companyKeywords === null
                    //     ? false
                    //     : profileDetails?.companyKeywords === ""
                    //       ? true
                    //       : false
                    // }
                    // helperText={
                    //   profileDetails?.companyKeywords === null
                    //     ? ""
                    //     : profileDetails?.companyKeywords === ""
                    //       ? "Company keywords is required"
                    //       : ""
                    // }
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        companyKeywords: e.target.value,
                      })
                    }
                    fullWidth
                    placeholder="Company Keywords"
                  />
                </Box>
              </Box>

              <Box
                display="flex"
                width="100%"
                // flexDirection={"column"}
                gap={4}
                mt={2}
                justifyContent="center"
                // border="2px solid blue"
              >
                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <FieldHeading children="Number of Employees" dialog />
                  <TextFieldMA
                    // disabled={editCompanyDescription}
                    size="small"
                    required
                    value={profileDetails?.numberOfEmployees}
                    type="number"
                    // error={
                    //   profileDetails?.numberOfEmployees === null
                    //     ? false
                    //     : profileDetails?.numberOfEmployees === ""
                    //       ? true
                    //       : false
                    // }
                    // helperText={
                    //   profileDetails?.numberOfEmployees === null
                    //     ? ""
                    //     : profileDetails?.numberOfEmployees === ""
                    //       ? "No of employee is required"
                    //       : ""
                    // }
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        numberOfEmployees: e.target.value,
                      })
                    }
                    fullWidth
                    placeholder="Number of Employees"
                  />
                </Box>
              </Box>
            </Box>
          )}

          {/* address */}
          {isCompanyProfileEdit.address && (
            <Box
              display={"flex"}
              width="100%"
              // gap={4}
              px={2}
              mb={2}
              // height={"25px"}
              flexDirection="column"
              // alignItems="center"
              // border="2px solid blue"
            >
              <Box
                display={"flex"}
                // width="100%"
                flex="1"
                gap="15px"
                minHeight={"40px"}
                maxHeight={"40px"}
                // paddingLeft="11px"
                // paddingRight="11px"
                alignItems="center"
                // backgroundColor={theme.col_3_alpha}
                borderRadius="6px"
              >
                <Typography
                  // padding="6px 6px 6px 11px"
                  flex="1"
                  fontSize={font.size.fs_5}
                  color={theme.col_2}
                  fontFamily={font.family.fm_2}
                  fontWeight="bold"
                >
                  Address
                </Typography>
                {false ? (
                  <IconButton onClick={() => setEditCompanyProfile(false)}>
                    <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
                  </IconButton>
                ) : (
                  <>
                    {/* {isCompanyProfileEdit.address && <IconButton disabled sx={{ ml: "auto" }}>
                    <Add sx={{ fontSize: "22px", color: theme.statusDisabled }} />
                  </IconButton>} */}
                    {/* {isCompanyProfileEdit.address && <Typography
                    // onClick={handleDetails}

                    // padding="6px 6px 6px 11px"
                    fontSize={font.size.fs_6}
                    color={theme.statusDisabled}
                    fontFamily={font.family.fm_2}
                    fontWeight="bold"
                  >
                    Add
                  </Typography>} */}
                    <Typography
                      onClick={handleUpdateAddressDetails}
                      // padding="6px 6px 6px 11px"
                      fontSize={font.size.fs_6}
                      color={
                        checkIfAddressValuesEqual() === true
                          ? theme.statusDisabled
                          : theme.col_3
                      }
                      fontFamily={font.family.fm_2}
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                    >
                      Save
                    </Typography>
                    <Typography
                      onClick={handleAddressDetailsCancel}
                      // padding="6px 6px 6px 11px"
                      fontSize={font.size.fs_6}
                      color={theme.col_2}
                      fontFamily={font.family.fm_2}
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                    >
                      Cancel
                    </Typography>
                  </>
                )}
              </Box>

              <Box
                display={"flex"}
                width="100%"
                gap="15px"
                // height={"25px"}
                // alignItems="center"
              >
                <Box
                  display="flex"
                  width="100%"
                  // flexDirection={"column"}
                  gap={4}
                  mt={2}
                  justifyContent="center"
                  // border="2px solid blue"
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap={1}
                    width="100%"
                  >
                    <FieldHeading children="Company Address" dialog />
                    <TextFieldMA
                      // disabled={editCompanyProfile}
                      size="small"
                      required
                      value={profileDetails?.companyAddress}
                      // error={
                      //   profileDetails?.companyAddress === null
                      //     ? false
                      //     : profileDetails?.companyAddress === ""
                      //       ? true
                      //       : false
                      // }
                      // helperText={
                      //   profileDetails?.companyAddress === null
                      //     ? ""
                      //     : profileDetails?.companyAddress === ""
                      //       ? "Company address is required"
                      //       : ""
                      // }
                      onChange={(e) =>
                        setProfileDetails({
                          ...profileDetails,
                          companyAddress: e.target.value,
                        })
                      }
                      fullWidth
                      placeholder="Company Address"
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
